'use client';

import React from 'react';
import Image from 'next/image';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DebugEditButton } from '@/components/mcp/debug/DebugEditButton';
import { cn } from '@/lib/utils';

const ImprovedInterviews: React.FC = () => {
  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    { id: 1, title: 'Verstehen', description: 'Verstehen, was du suchst', content: 'Wir lernen dich, deine Fähigkeiten und deine Ziele genau kennen, um den perfekten Job für dich zu finden. Deine Präferenzen stehen im Mittelpunkt.', image: '/hero-section-verstehen.png' },
    { id: 2, title: 'Suchen', description: 'Aktive Job-Suche für dich', content: 'Unsere KI durchsucht den Markt gezielt nach passenden Stellen. Gleichzeitig sprechen wir proaktiv Unternehmen an, die zu deinem Profil passen könnten.', image: '/hero-section-suchen.png' },
    { id: 3, title: 'Matching', description: 'Intelligentes Matching', content: 'Passt ein Job zu dir? Wir prüfen das genau – fachlich und kulturell. KI hilft uns dabei, aber die menschliche Einschätzung entscheidet mit.', image: '/hero-section-kandidat-matching.png' },
    { id: 4, title: 'Begleiten', description: 'Transparente Begleitung', content: 'Du bist immer im Bilde. Wir kommunizieren offen während des gesamten Prozesses und du erhältst zu jeder Entscheidung klares, ehrliches Feedback.', image: '/hero-section-begleiten.png' },
    { id: 5, title: 'Partnerschaft', description: 'Langfristige Perspektive', content: 'Unser Ziel ist dein Erfolg. Auch wenn es nicht sofort klappt, unterstützen wir dich weiter auf deinem Karriereweg und lernen kontinuierlich dazu.', image: '/hero-section-partnerschaft.png' },
  ];

  return (
    <div className="w-full py-16 bg-black-50">
      <div className="container mx-auto flex flex-col items-center">
        <div className="flex flex-wrap justify-center space-x-2 md:space-x-4 mb-4 md:mb-8">
          {tabs.slice(0, 3).map(tab => (
            <Button
              key={tab.id}
              variant={activeTab === tab.id ? 'default' : 'outline-primary'}
              size="lg"
              className={cn(
                'transition-colors duration-200',
                activeTab === tab.id 
                  ? 'bg-true-blue text-white hover:bg-true-blue/90' 
                  : 'bg-white text-true-blue border-true-blue hover:bg-true-blue/10'
              )}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.title}
            </Button>
          ))}
        </div>
        <div className="flex flex-wrap justify-center space-x-2 md:space-x-4 mb-4 md:mb-8">
          {tabs.slice(3).map(tab => (
            <Button
              key={tab.id}
              variant={activeTab === tab.id ? 'default' : 'outline-primary'}
              size="lg"
              className={cn(
                'transition-colors duration-200',
                activeTab === tab.id 
                  ? 'bg-true-blue text-white hover:bg-true-blue/90' 
                  : 'bg-white text-true-blue border-true-blue hover:bg-true-blue/10'
              )}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.title}
            </Button>
          ))}
        </div>
        <div className="flex flex-col md:flex-row items-center max-w-6xl mx-auto">
          {tabs.map(tab => (
            <div key={tab.id} className={`tab-content ${activeTab === tab.id ? 'block' : 'hidden'}`}>
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 p-4 text-center md:text-left">
                  <h3 className="text-h3 font-gilroy mb-2">{tab.description}</h3>
                  <p className="text-body mb-4">{tab.content}</p>
                </div>
                <div className="md:w-1/2 p-4 flex justify-center md:justify-end relative group">
                  <Image src={tab.image} alt={tab.description} width={500} height={300} className="img-fluid h-64 object-cover rounded-xl" />
                  
                  {/* Debug edit button - only shown in debug mode and on hover */}
                  <DebugEditButton 
                    imageName={tab.image.split('/').pop()?.split('.')[0] || ''}
                    imageUrl={tab.image}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { ImprovedInterviews };